export const invoice_lange={
  TH:{
      customer_data:"ข้อมูลลูกค้า",
      invoice_id: "รหัสใบแจ้งหนี้",
      create_datetime: "วันที่ออกใบชำระ",
      customer_id: "รหัสลูกค้า",
      customer_name: "ชื่อลูกค้า",
      mobile:"เบอร์โทรศัพท์",
      email:"อีเมล์",
      due_date: "วันเวลาชำระ",
      fee_description: "รายละเอียดค่าธรรมเนียม",
      fee_id: "รหัสค่าธรรมเนียม",
      fee_price: "ค่าธรรมเนียม",
      fee_type_description: "ชนิดค่าธรรมเนียม",
      total_price: "ราคารวม",
      user_id: "ผู้ออกใบ",
      username: "ชื่อผู้ออกใบ",
      vat: "ภาษี",
      vat_rate: "อัตราภาษี",
      update:"ชำระเงิน",
      delete:"ลบ",
      payment_datetime:"วันที่ชำระ",
      search:"ค้นหา",
      no_internet:"เกิดข้อผิดพลากในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
      back_to_paybill:"กลับไปเสดงรายการการชำระ",
      paytype:"เลือกวิธีการชำระเงิน",
      fee_data:"ข้อมูลค่าธรรมเนียม",
      close:"ปิดหน้านี้",
      update_data:"ชำระเงิน",
      alert_select_paytype:"กรุณาเลือกประการชำระเงิน",
      confirm_update:"คุณต้องการชำระเงินใช่หรือไหม?",
      want_update:"ชำระเงิน",
      updated:"ข้อมูลถูกอัพเดทเรียบร้อยแล้ว",
      confirm_delete:"คุณต้องการยกเลิกข้อมูลการชำระเงินนี้ใช่หรือไหม?",
      warining_delete:"ข้อมูลยกเลิกแล้วไม่สามารถยอนกลับได้!!",
      want_delete:"ฉันต้องการยกเลิก",
      payment_type:"ประเภทการชำระ",
      detail:"ดูรายการ",
      bill_id:"รหัสใบเสร็จรับเงิน",
      save:"บันทึก",
      saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว",
      start_date:"วันเริ่มต้น",
      end_date:"วันสุดท้าย",
      user_error:"กรุณาเลือกผู้ออกใบ",
      start_date_error:"กรุณาเลือกวันเริ่มต้น",
      end_date_error:"กรุณาเลือกเวลาสุดท้าย",
      dis:"ราคาลด(-)/ราคาเพิ่ม(+)",
      clear:"ล้างข้อมูล",
      price:"ราคาที่จ่าย",
      print_bill:"พิมพ์ใบเสร็จรับเงิน",
      cancel_bill:"ยกเลิกใบเสร็จรับเงิน",
      cancel_title: "ต้องการยกเลิกใบเสร็จรับเงินนี้ใช่หรือไม่?",
      cancel_detail: "กรุณายืนยันข้อมูล",
      request_general_id:"หมายเลขคำร้อง",
      request_alert:"กรุณากรอกหมายเลขคำร้อง",
      employee_id: "ผู้ออกใบ",

  },
  EN:{
      customer_data:"customer detail",
      bill_id: "bill ID",
      create_datetime: "create date",
      customer_id: "customer ID",
      customer_name: "customer name",
      mobile:"phone number",
      email:"email",
      due_date: "paid date",
      fee_description: "fee description",
      fee_id: "fee ID",
      fee_price: "fee price",
      fee_type_description: "fee type",
      total_price: "total price",
      user_id: "user id",
      username:"user name",
      vat: "vat",
      vat_rate: "vat rate",
      update:"bill",
      delete:"delete",
      search:"search",
      no_internet:"connection eror please check you connection!",
      back_to_paybill:"back to paybill data",
      paytype:"choose payment type",
      fee_data:"fee detail",
      close:"close this page",
      update_data:"Pay bill",
      alert_select_paytype:"please choose your payment type",
      confirm_update:"Are you sure to pay this bill?",
      want_update:"Yes I'm",
      updated:"This data was updated",
      confirm_delete:"Are you sure to delete this pay bill item?",
      warining_delete:"deleted data can't recovery!",
      want_delete:"Yes delete it",
      payment_type:"payment type",
      detail:"view detail",
      invoice_id:"invoice ID",
      save:"save",
      saved:"data was saved",
      start_date:"start date",
      end_date:"end_date",
      user_error:"please choose user ",
      start_date_error:"please choose start date",
      end_date_error:"please choose end date",
      payment_datetime:"payment date",
      dis:"discount",
      clear:"clear",
      price:"payment price",
      print_bill:"print payment",
      cancel_bill:"Cancel",
      cancel_title: "Are you sure to cancel this bill??",
      cancel_detail: "Please confirm.",
      request_general_id:"request general id",
      request_alert:"please input request general id",
      employee_id: "EMPLOYEE ID",

  }
}
